import { render, staticRenderFns } from "./card_item.vue?vue&type=template&id=36daa76a&scoped=true"
import script from "./card_item.vue?vue&type=script&lang=js"
export * from "./card_item.vue?vue&type=script&lang=js"
import style0 from "./card_item.vue?vue&type=style&index=0&id=36daa76a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36daa76a",
  null
  
)

export default component.exports